import {apiGet} from '@api/api'
import {ApiRes} from '@type/api'
import {IProfile} from '@type/profile'
import {IApiGetSidebarKeyIdProps} from '@api/user/sidebar/getSidebar'

export const apiGetProfile = async (id: string, props?: IApiGetSidebarKeyIdProps): Promise<ApiRes<IProfile>> => {
    return await apiGet(`user/profile/${id}`, {cookies: props?.cookie})
}
